import { render } from "./App.vue?vue&type=template&id=7c545413"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7c545413&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__